import React from 'react';
import { motion } from 'framer-motion';
const works = [{
  id: 1,
  src: 'https://images.unsplash.com/photo-1576566588028-4147f3842f27?q=80&w=800&auto=format&fit=crop',
  alt: 'Custom T-Shirt Print'
}, {
  id: 2,
  src: 'https://images.unsplash.com/photo-1562157873-818bc0726f68?q=80&w=800&auto=format&fit=crop',
  alt: 'Embroidered Hat'
}, {
  id: 3,
  src: 'https://images.unsplash.com/photo-1503341504253-dff4815485f1?q=80&w=800&auto=format&fit=crop',
  alt: 'Screen Printing Detail'
}, {
  id: 4,
  src: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?q=80&w=800&auto=format&fit=crop',
  alt: 'Workshop Production'
}, {
  id: 5,
  src: 'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?q=80&w=800&auto=format&fit=crop',
  alt: 'Black Hoodie Print'
}, {
  id: 6,
  src: 'https://images.unsplash.com/photo-1562157617-3798681a8809?q=80&w=800&auto=format&fit=crop',
  alt: 'DTF Transfer Sheet'
}];
export function FeaturedWork() {
  return <section className="py-24 bg-atomic-black" data-id="element-29">
      <div className="container mx-auto px-4 md:px-6" data-id="element-30">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-31">
          <div data-id="element-32">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-33">
              Featured Work
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-34">
              Real production. Real results.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-35">
          {works.map((work, index) => <motion.div key={work.id} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="aspect-square relative overflow-hidden rounded-lg group" data-id="element-36">
              <img src={work.src} alt={work.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-37" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-300" data-id="element-38" />
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-39">
                <span className="text-white font-bold text-lg tracking-wider border-b-2 border-atomic-red pb-1" data-id="element-40">
                  VIEW
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}